import React from 'react'

interface MapMarkerIconProps extends React.SVGProps<SVGSVGElement> {
  width?: string | number
  height?: string | number
  fill?: string
}

export const MapMarkerIcon: React.FC<MapMarkerIconProps> = ({
  width = '16',
  height = '16',
  fill = '#757575',
  ...props
}) => (
  <svg viewBox="0 0 16 16" width={width} height={height} fill="none" {...props}>
    <path
      d="M7.99992 7.66659C7.55789 7.66659 7.13397 7.49099 6.82141 7.17843C6.50885 6.86587 6.33325 6.44195 6.33325 5.99992C6.33325 5.55789 6.50885 5.13397 6.82141 4.82141C7.13397 4.50885 7.55789 4.33325 7.99992 4.33325C8.44195 4.33325 8.86587 4.50885 9.17843 4.82141C9.49099 5.13397 9.66659 5.55789 9.66659 5.99992C9.66659 6.21879 9.62348 6.43552 9.53972 6.63772C9.45596 6.83993 9.33319 7.02367 9.17843 7.17843C9.02367 7.33319 8.83993 7.45596 8.63772 7.53972C8.43552 7.62348 8.21879 7.66659 7.99992 7.66659ZM7.99992 1.33325C6.76224 1.33325 5.57526 1.82492 4.70009 2.70009C3.82492 3.57526 3.33325 4.76224 3.33325 5.99992C3.33325 9.49992 7.99992 14.6666 7.99992 14.6666C7.99992 14.6666 12.6666 9.49992 12.6666 5.99992C12.6666 4.76224 12.1749 3.57526 11.2998 2.70009C10.4246 1.82492 9.2376 1.33325 7.99992 1.33325Z"
      fill={fill}
    />
  </svg>
)
